import axios from "axios";
import { useEffect, useState } from "react";
import { open } from "../firebaseConfig";

export const teamNames = ["hur", "gla", "pen", "cbd"];

const emptyTeamObject = { hur: [], cbd: [], pen: [], gla: [] };

const genUrl = (id) =>
  `https://statsapi.web.nhl.com/api/v1/people/${id}/stats?stats=statsSingleSeasonPlayoffs&season=20222023`;

export const useScores = () => {
  const [openData, setOpenData] = useState(emptyTeamObject);
  const [urls, setUrls] = useState();
  const [cbd, setcbd] = useState();
  const [hur, sethur] = useState();
  const [gla, setgla] = useState();
  const [pen, setpen] = useState();
  const [returnData, setReturnData] = useState(null);
  const [bp, setBP] = useState(emptyTeamObject);

  useEffect(() => {
    setBP({
      hur: 11,
      cbd: 6,
      pen: 10,
      gla: 6,
    });
  }, []);

  const calcPlayerScore = (a, g, ppp, shg) => {
    return a * 2 + g * 3 + ppp + shg * 2;
  };

  const calcGoalieScore = (ga, gs, so, w) => {
    return gs + w * 7 - ga + so * 3;
  };

  useEffect(() => {
    const calculatePlayerScores = (fullTeamData) => {
      let returnData = {};
      // console.log("👈️👈️👈️👈️👈️", returnData);
      Object.keys(fullTeamData).forEach((teamId) => {
        // console.log(teamId);
        returnData[teamId] = [];
        fullTeamData[teamId].forEach((player) => {
          const isGoalie = player.data.position.type === "Goalie";
          if (isGoalie) {
            // console.log("GOALIE SCORE:");
            // console.log(item.score.ga);
            const totalScore = calcGoalieScore(
              player.score.ga,
              player.score.gs,
              player.score.so,
              player.score.w
            );
            // console.log("GOALIE TOTAL SCORE", totalScore);
            returnData[teamId].push({
              ...player,
              score: { ...player.score, score: totalScore },
            });
          } else {
            // console.log("player score:");
            // console.log(player.score);
            const totalScore = calcPlayerScore(
              player.score.a,
              player.score.g,
              player.score.ppp,
              player.score.shg
            );
            returnData[teamId].push({
              ...player,
              score: { ...player.score, score: totalScore },
            });
          }
        });
      });
      // console.log("🕋", returnData);
      return returnData;
    };
    const calculateTeamScores = (teamWithPlayerScores) => {
      // console.log(teamWithPlayerScores);
      let returnData = { ...teamWithPlayerScores };
      Object.keys(teamWithPlayerScores).forEach((teamName) => {
        let teamScore = 0;
        // console.log("🎳", teamName);
        // console.log(
        teamWithPlayerScores[teamName].forEach((playerInfo) => {
          // console.log("🧠---------------------");
          // console.log("🔥", playerInfo.data.person.fullName);
          // console.log(playerInfo.score.score);
          teamScore += playerInfo.score.score;
          // ////////////////////////////
          //
          // ******* SOME SCORES ARE undefined
          // teamScore += score.score.score;
          //
          // ///////////////////////////
        });
        // );
        // console.log(teamScore);
        returnData[teamName].totalScore = teamScore;
      });
      // console.log(returnData);
      return returnData;
    };
    const sortTeamsByScore = (teamsFullScores) => {
      // console.log("🍅", teamsFullScores);
      const returnData = { ...teamsFullScores, standings: [] };
      const finalScores = [];

      Object.keys(teamsFullScores).map((teamName) => {
        console.log(bp[teamName]);
        return [
          // console.log(teamsFullScores[teamName].totalScore),
          finalScores.push({
            teamName,
            score: teamsFullScores[teamName].totalScore + bp[teamName],
          }),
        ];
      });

      console.log(finalScores);

      finalScores.sort((a, b) => {
        return a.score - b.score;
      });
      // console.log("🏈", finalScores);
      returnData.standings = finalScores.reverse();
      // console.log(returnData);
      return returnData;
    };
    // console.log("🍄🍄🍄", { cbd, pen, hur, gla });
    const ready =
      cbd &&
      cbd.length === 20 &&
      pen &&
      pen.length === 20 &&
      gla &&
      gla.length === 20 &&
      hur &&
      hur.length === 20;
    // if (!cbd) return;
    // if (!pen) return;
    // if (!gla) return;
    // if (!hur) return;
    if (!ready) return;
    const teamsWithPlayerScores = calculatePlayerScores({ cbd, pen, gla, hur });
    const teamsWithPlayerAndTeamScores = calculateTeamScores(
      teamsWithPlayerScores
    );
    setReturnData(sortTeamsByScore(teamsWithPlayerAndTeamScores));
  }, [cbd, pen, gla, hur, bp]);

  const setData = async () => {
    setOpenData(await open());
  };

  useEffect(() => {
    const handleApiData = (data, team, setTeam, teamName) => {
      // console.log("🥩🥩🥩🥩🥩🥩", data)
      // console.log("HANDLING API DATA, ", data, team, setTeam)
      const allScore = data.map((i) => {
        let playerData;
        const url = i.config.url;
        // BUG HERE
        // console.log("🌞", i.data.stats[0].splits[0])
        const stat = i.data.stats[0].splits[0]
          ? i.data.stats[0].splits[0].stat
          : [];
        // BUG HERE
        openData[teamName].forEach((p) => {
          // console.log(p.person.id)
          // console.log("url", url)
          if (genUrl(p.person.id) === url) playerData = p;
        });
        // console.log(i.data.stats[0].splits[0], playerData)
        // console.log(i.data.stats[0].splits[0].stat)
        // console.log("🧱 Data", playerData)
        // console.log("🧱 Stat,", stat)
        let newPlayerScore = {
          gp: stat.games || 0,
          ppp: stat.powerPlayPoints || 0,
          shg: stat.shortHandedGoals || 0,
          a: stat.assists || 0,
          g: stat.goals || 0,
          gs: stat.gamesStarted || 0,
          w: stat.wins || 0,
          ga: stat.goalsAgainst || 0,
          so: stat.shutouts || 0,
          score: -1,
        };
        return { stats: stat, score: newPlayerScore, data: playerData };
      });
      // console.log(allScore)
      setTeam(allScore);
    };
    const handleURLs = async () => {
      // console.log("handleAllUrls", urls)
      const { cbd, hur, pen, gla } = urls;
      // console.log({ cbd, hur, pen, gla })

      axios
        .all(pen.map((endpoint) => axios.get(endpoint)))
        .then((data) => handleApiData(data, pen, setpen, "pen"));

      axios
        .all(gla.map((endpoint) => axios.get(endpoint)))
        .then((data) => handleApiData(data, gla, setgla, "gla"));
      axios
        .all(hur.map((endpoint) => axios.get(endpoint)))
        .then((data) => handleApiData(data, hur, sethur, "hur"));
      axios
        .all(cbd.map((endpoint) => axios.get(endpoint)))
        .then((data) => handleApiData(data, cbd, setcbd, "cbd"));
    };
    if (!urls) return;
    handleURLs();
    // console.log("URLS READY?", urls)
  }, [openData, urls]);

  useEffect(() => {
    setData();
  }, []);

  useEffect(() => {
    const getUrls = () => {
      if (!openData.cbd) return;
      setUrls({
        cbd: openData.cbd.map((p) => genUrl(p.person.id)),
        pen: openData.pen.map((p) => genUrl(p.person.id)),
        gla: openData.gla.map((p) => genUrl(p.person.id)),
        hur: openData.hur.map((p) => genUrl(p.person.id)),
      });
    };
    if (!openData) return;
    // console.log({ openData })
    getUrls();
  }, [openData]);
  return { data: returnData, bracketPoints: bp };
};
